<template>
  <div class="verify_box">
    <p>{{titleTxt}}</p>
    <p class="userEmail">{{$t('verifyText.title1')}}：{{accountStorageEmail}}</p>
    <div class="form_item">
      <div class="form_input psw_input">
        <input type="text"
               v-model="verify_code"
               :placeholder="$t('toast.verifyTitle')"
               class="psw">
        <button class="psw_btn"
                :disabled="showIndex"
                :class="{ disabled: showIndex }"
                @click="clickVerifyCode">{{btnValue}}</button>
      </div>
    </div>
    <li class="form_item "
        :class="noclickFlag?'form_submit':'form_no_submit'"
        ref="form_submit"
        @click="terminalLogin">
      {{$t('toast.comfirmBtn1')}}
    </li>
  </div>
</template>

<script>
import { mailMosk } from '@/utils/utils'
import initNECaptchaWithFallback from '@/assets/js/yidun-captcha'
import { queryPhone, forget_password_verify_code } from '@/api/login'
import { send_verify_code_self } from '@/api/hw'
import { check_terminal } from '@/api/hw'
import { getSessionStorage, setSessionStorage, setToken } from '@/utils/stage'
export default {
  data() {
    return {
      verify_code: '',
      scene_id: 1,
      showIndex: false,
      NECaptcha: '',
      validate: '',
      codeFlag: false,
      ydErr: false,
      configData: '',
      phone_token: '',
      btnValue: this.$t('toast.verifycodeBtn'),
      titleTxt: '',
      paramsId: '',
      routerUrl: '',
      accountStorageEmail: '',
      verify_type: '',
      terminalType: 2,
      noclickFlag: false,
    }
  },
  watch: {
    verify_code(newVal) {
      if (newVal) {
        this.noclickFlag = true
      } else {
        this.noclickFlag = false
      }
    },
  },
  created() {
    this.init()
  },
  mounted() {
    this.NECaptchaInit()
  },
  methods: {
    init() {
      this.terminal = JSON.parse(getSessionStorage('accountStorage')).email
      this.configData = JSON.parse(getSessionStorage('message'))
      this.accountStorageEmail = mailMosk(this.terminal)
      this.paramsId = this.$route.query.id
      //   id=1 修改账号名 id=2
      if (this.paramsId == 1) {
        this.titleTxt = this.$t('verifyText.titleTxt1')
        //   '为了保护您的账号安全，设置新的账号名前，前先验证账号绑定的邮箱'
        this.routerUrl = '/setName'
        this.scene_id = 1
        this.verify_type = 2
      } else if (this.paramsId == 2) {
        this.titleTxt = this.$t('verifyText.titleTxt2')
        //   '为了保护您的账号安全，关联新账号前，前先验证账号绑定的邮箱'
        this.routerUrl = '/associatedAccount'
        this.verify_type = 2
      } else if (this.paramsId == 3) {
        this.titleTxt = this.$t('verifyText.titleTxt3')
        // this.titleTxt = `为了保护您的账号安全，修改密码前，请先验证账号绑定的邮箱`
        this.routerUrl = '/changePassword'
        this.scene_id = 10
        this.verify_type = 1
      } else if (this.paramsId == 4) {
        this.titleTxt = this.$t('verifyText.titleTxt4')
        //   '为了保护您的账号安全，进行设备管理前，前先验证账号绑定的邮箱'
        this.routerUrl = '/loginrecord'
        this.verify_type = 2
        this.scene_id = 1
      } else if (this.paramsId == 5) {
        this.titleTxt = this.$t('verifyText.titleTxt5')
        // ;('为了保护您的账号安全，换绑邮箱前，请先验证账号目前绑定的邮箱')
        this.routerUrl = '/changeEmail'
        this.scene_id = 12
        this.verify_type = 1
      }
      this.getWm()
    },
    NECaptchaInit() {
      const captchaId = this.$store.getters.captcha_id
      var that = this
      var neWidth = 320 + 'px'
      initNECaptchaWithFallback(
        {
          // config对象，参数配置
          captchaId: captchaId, // 从易盾申请的验证码id
          element: '#captcha', // 容器元素/容易元素选择器
          mode: 'bind', // 验证码模式
          width: neWidth, // 验证按钮宽度，推荐260px-400px
          defaultFallback: false,
          onVerify: function (err, data) {
            // 验证码验证结束回调函数
            // that.validate = data
            if (data) {
              that.sendVerifyCode(data.validate)
              that.NECaptchaInit()
            }
          },
        },
        function onload(instance) {
          // 初始化成功后得到验证实例instance，可以调用实例的方法。
          that.NECaptcha = instance
          that.ydErr = true
        },
        function onerror(err) {
          that.ydErr = false
          // 初始化失败后触发该函数，err对象描述当前错误信息
          console.log(err)
        }
      )
    },
    clickVerifyCode() {
      if (this.ydErr) {
        this.NECaptcha && this.NECaptcha.verify()
      } else {
        this.sendVerifyCode()
        return
      }
    },

    sendVerifyCode(valid) {
      let validateData = ''
      if (typeof valid === 'string') {
        validateData = valid
      }
      if (!this.codeFlag) {
        this.codeFlag = true
        const access_token = JSON.parse(
          getSessionStorage('accountStorage')
        ).access_token
        const data = {
          terminal_type: this.terminalType,
          scene_id: this.scene_id,
          validate: validateData,
          access_token,
        }
        const msg = Object.assign(
          JSON.parse(JSON.stringify(this.configData)),
          data
        )
        send_verify_code_self(msg).then((res) => {
          this.getCode()
          if (res.errcode === 503) {
            if (this.ydErr) {
              this.NECaptcha && this.NECaptcha.verify()
            } else {
              this.sendVerifyCode()
            }
          } else if (res.errcode === 0) {
            this.$toast(res.errmsg)
            // this.$getburiedPoint('verify_phone-4', '0-011')
          }
        })
      }
      setTimeout(() => {
        this.codeFlag = false
      }, 1000)
    },
    getWm() {
      const _this = this
      if (window.wm) {
        window.wm &&
          window.wm.getToken(
            this.$store.getters.yd_product_id,
            function (token) {
              _this.token = token
            },
            function (error) {
              // 错误处理
              _this.token = ''
            }
          )
      }
    },
    getCode() {
      this.showIndex = true
      let show = true
      let count = ''
      let timer = null
      const TIME_COUNT = 60
      if (!timer) {
        count = TIME_COUNT
        show = false
        timer = setInterval(() => {
          if (count > 0 && count <= TIME_COUNT) {
            count--
          } else {
            show = true
            clearInterval(timer)
            timer = null
          }
          if (count === 0) {
            this.btnValue = this.$t('toast.verifycodeBtn2')
            this.showIndex = false
            return
          } else {
            this.btnValue = count + 's'
          }
        }, 1000)
      }
    },
    terminalLogin() {
      if (this.loginFlag) {
        return
      }
      this.loginFlag = true
      setTimeout(() => {
        this.loginFlag = false
      }, 2000)

      if (!this.verify_code) {
        this.$toast(this.$t('toast.verifyTitle'))
        return
      }
      const that = this
      const access_token = JSON.parse(
        getSessionStorage('accountStorage')
      ).access_token
      if (this.verify_type == 2) {
        const data = {
          terminal_type: 2,
          type: this.verify_type,
          verify_code: that.verify_code,
          access_token: access_token,
        }
        const msg = Object.assign(
          JSON.parse(JSON.stringify(that.configData)),
          data
        )
        check_terminal(msg).then((res) => {
          const time1 = res.data.csrf_token.substring(0, 10)
          const time = this.humandate(time1)
          const csrf_token_info = {
            csrf_token: res.data.csrf_token,
            id: JSON.parse(getSessionStorage('accountStorage')).open_id,
          }
          setToken('csrf_token_info', JSON.stringify(csrf_token_info), time)
          this.$router.push(this.routerUrl)
        })
      } else if (this.verify_type == 1 && this.paramsId == 4) {
        const data = {
          phone_token: this.phone_token,
          verify_code: this.verify_code,
        }
        const msg = Object.assign(
          JSON.parse(JSON.stringify(this.configData)),
          data
        )
        forget_password_verify_code(msg).then((res) => {
          setSessionStorage('accountveify', res.data.csrf_token)
          this.$router.push({ path: '/changePassword' })
        })
      } else {
        const data = {
          terminal_type: 2,
          type: this.verify_type,
          verify_code: that.verify_code,
          access_token: access_token,
        }
        const msg = Object.assign(
          JSON.parse(JSON.stringify(that.configData)),
          data
        )
        check_terminal(msg).then((res) => {
          setSessionStorage('accountveifyOne', res.data.csrf_token)
          this.$router.push(this.routerUrl)
        })
      }
    },
    humandate(time1) {
      var time2 = Date.parse(new Date())
      var s = (time1 - time2 / 1000 - 300) / 3600 / 24
      return s
    },
    queryAccount(data) {
      const msg = Object.assign(JSON.parse(JSON.stringify(this.configData)), {
        account: data,
      })
      queryPhone(msg).then((res) => {
        this.phone_token = res.data.phone_token
        setSessionStorage('accountInfo', JSON.stringify(res.data))
      })
    },
  },
}
</script>

<style scope lang="less">
.verify_box {
  padding: 30/75rem;
  p {
    font-size: 24/75rem;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #575757;
    margin-bottom: 20/75rem;
  }
  .userEmail {
    font-size: 28/75rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #575757;
  }
  .form_item {
    margin-top: 30/75rem;

    .form_input {
      width: 610/75rem;
      height: 80/75rem;
      border: 1px solid #575757;
      opacity: 1;
      border-radius: 6/75rem;
      padding-left: 30/75rem;
      padding-top: 21/75rem;
      box-sizing: border-box;
      margin: 0 auto;
      .phone {
        border: none;
        outline: none;
        width: 100%;
        height: 34/75rem;
      }
      .psw {
        border: none;
        outline: none;
        width: 470/75rem;
        width: 100%;
      }
    }
    .psw_input {
      padding-right: 180/75rem;
      box-sizing: border-box;
      position: relative;
      .psw_btn {
        background: none;
        border: none;
        outline: none;
        position: absolute;
        display: inline-block;
        width: 180/75rem;
        right: 0;
        top: 0;
        height: 76/75rem;
        line-height: 76/75rem;
        letter-spacing: 5/75rem;
        &:before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          width: 1px;
          height: 45/75rem;
          background: #cfcfcf;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>